exports = module.exports = require("../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._32rHD8Rlbde99cXxhaIhzU{width:100%}._32rHD8Rlbde99cXxhaIhzU .pickup-time-detail{overflow-wrap:break-word;width:inherit}._32rHD8Rlbde99cXxhaIhzU .tracking-code-detail{overflow-wrap:break-word;width:inherit}._32rHD8Rlbde99cXxhaIhzU .separator{margin:0 auto;padding:0 5%}\n", ""]);

// exports
exports.locals = {
	"recipientPickupText": "_32rHD8Rlbde99cXxhaIhzU"
};